import { render, staticRenderFns } from "./BarMetricCard.vue?vue&type=template&id=5de818e0&"
import script from "./BarMetricCard.vue?vue&type=script&lang=ts&"
export * from "./BarMetricCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports